export const POGIS_DOCUMENT_TRANSLATION_NAMESPACE = 'features/pogisdocuments';
